module.exports = __webpack_public_path__ + "static/img/liveroom.1bbd882.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/liveroom.png
// module id = 8pe2
// module chunks = 1